// features/health-insurance/health-insurance.service.ts
import { post } from '../../api/api.service';

export interface HealthInsuranceFormPayload {
  firstName: string;
  lastName: string;
  email: string;
  address: string;
  ssn?: string;
  lang: string;
  type: number;
}

export const submitHealthInsuranceFormApi = async (payload: HealthInsuranceFormPayload) => {
  try {
    const response = await post<any>('/contactus/private-insurance-feature', payload);
    return response;
  } catch (error) {
    throw error;
  }
};
